import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toastService } from "../../utils/toastify";
import userImg from "../../assets/images/admin.png";
import { replyToRating } from "../../features/slices/courseDetails";
import { useDispatch } from "react-redux";
import { getPodcastDetail } from "../../features/slices/poadcast";
const PoadcastRating = () => {
  const [ratingByAdmin, setRatingByAdmin] = useState("");
  const [detailedRating, setDetailedRating] = useState([{}]);
  const { state } = useLocation();
  const dispatch = useDispatch();
  console.log({ state });
  const [isRatingAdmin, setIsRatingAdmin] = useState([]);
  useEffect(() => {
    if (state) {
      if (state?.type == "studentManagemnt") {
        dispatch(getPodcastDetail({ id: state?.podcastData?.[0]?._id })).then(
          (res) => {
            if (res?.payload?.code == 200) {
              console.log({ res });
              setIsRatingAdmin(res?.payload?.result?.[0]?.ratingData);
            }
          }
        );
      } else {
        dispatch(getPodcastDetail({ id: state?._id })).then((res) => {
          if (res?.payload?.code == 200) {
            console.log({ res });
            setIsRatingAdmin(res?.payload?.result?.[0]?.ratingData);
          }
        });
      }
    }
  }, [state]);
  console.log({ isRatingAdmin });
  useEffect(() => {
    if (state) {
      const obj = {};
      if (state?.ratingCounts?.length > 0) {
        state?.ratingCounts?.forEach((rating) => {
          if (rating?.startCount in obj) {
            obj[rating?.startCount]++;
          } else {
            obj[rating?.startCount] = 1;
          }
        });
        const star = [
          ...new Set(
            state?.ratingCounts?.map((result) => result?.startCount || 0)
          ),
        ];

        const fullDetailRating = star?.map((str) => ({
          precentage: (obj[str] / state?.ratingCounts?.length) * 100 || 0,
          star: str,
        }));

        setDetailedRating(fullDetailRating);
      } else {
        setDetailedRating([]);
      }
    }
  }, []);
  const handleSubmit = (id) => {
    const data = {
      id,
      ratingByAdmin,
    };
    dispatch(replyToRating(data)).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getPodcastDetail({ id: state?._id })).then((res) => {
          if (res?.payload?.code == 200) {
            console.log({ res });
            setIsRatingAdmin(res?.payload?.result?.[0]?.ratingData);
          }
        });
        toastService.success("Reply to rating successfully");
        setRatingByAdmin("");
      } else {
        toastService.error("Reply to rating failed");
      }
    });
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Rating and Reviews</h4>
          </div>
          <div className="LiveStreamAreaArea">
            <div className="AverageReviewBox">
              <h4>Average Review</h4>
              <aside>
                <h5>{Math.round(state?.averageRating)}</h5>
                <div className="Ratings">
                  {Array.from({ length: 5 }, (_, index) => {
                    return (
                      <span key={index}>
                        <i
                          className={
                            index < Math.round(state?.averageRating)
                              ? "fa-solid fa-star checked"
                              : "fa-regular fa-star"
                          }
                        />
                      </span>
                    );
                  })}
                </div>
                <p>Rating</p>
              </aside>
            </div>
            <div className="ProgressBarArea">
              <h4>Detailed Rating</h4>
              <ul>
                {detailedRating.length > 0 ? (
                  detailedRating?.map((detailRat, i) => {
                    return (
                      <li key={i}>
                        <label>{detailRat?.precentage?.toFixed(2) || 0}%</label>
                        <div className="Ratings d-flex">
                          {Array.from({ length: 5 }, (_, index) => (
                            <span key={index}>
                              <i
                                className={
                                  index < detailRat?.star
                                    ? "fa-solid fa-star checked"
                                    : "fa-regular fa-star"
                                }
                              />
                            </span>
                          ))}
                        </div>
                        <div className="ProgressBar">
                          <span
                            className="Progress"
                            style={{
                              width: `${
                                detailRat?.precentage?.toFixed(2) || 0
                              }%`,
                            }}
                          />
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <li>
                    <label>{0}%</label>
                    <div className="Ratings d-flex">
                      {Array.from({ length: 5 }, (_, index) => (
                        <span key={index}>
                          <i className="fa-regular fa-star" />
                        </span>
                      ))}
                    </div>
                    <div className="ProgressBar Width">
                      <span
                        className="Progress"
                        style={{
                          width: `0%`,
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div style={{ clear: "both" }} />
          <div className="RatingComment">
            {isRatingAdmin?.map((data, i) => {
              return (
                <article key={i}>
                  <aside>
                    <figure>
                      <img src={data?.user?.profilePic || userImg} />
                    </figure>
                    <figcaption>
                      <h6>{data?.user?.fullName}</h6>
                      <div className="Ratings">
                        {Array.from({ length: 5 }, (_, index) => (
                          <span key={index}>
                            <i
                              className={
                                index < data?.startCount
                                  ? "fa-solid fa-star"
                                  : "fa-regular fa-star"
                              }
                            />
                          </span>
                        ))}
                      </div>
                    </figcaption>
                  </aside>
                  <p>{data?.comment}</p>
                  {data?.is_rating_admin ? (
                    <p className="reviewReply">{data?.ratingByAdmin}</p>
                  ) : (
                    <>
                      <div className="RatingForm ">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Make feedback here..."
                            rows={4}
                            defaultValue={""}
                            onChange={(e) => setRatingByAdmin(e.target.value)}
                          />
                        </div>
                      </div>
                      <button
                        className="Button"
                        onClick={() => handleSubmit(data?._id)}
                      >
                        Submit Row
                      </button>
                    </>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoadcastRating;
